import React, {Component} from 'react';

import {pushEdapEvent} from '../../../utils/edap';

export function ErrorPanel({error}) {
    return (
        <div style={{backgroundColor: 'red', color: 'white'}}>
            {error.toString()}
        </div>
    );
}

export function getComponentOrElementDebugName(
    cmp = {type: 'UnknownComponent'}
) {
    const {props, type} = cmp;

    const typeName =
        typeof type === 'string' ? type : type.displayName || type.name;

    let idClassName = '';
    if (Object.prototype.toString.call(props) === '[object Object]') {
        if (typeof props.id === 'string') {
            idClassName += `#${props.id}`;
        }

        if (typeof props.className === 'string') {
            idClassName += `.${props.className.split(' ').join('.')}`;
        }
    }

    return `${typeName}${idClassName}`;
}

export function buildComponentPath(child, path = []) {
    if (!path.length && child._owner) {
        path.push(getComponentOrElementDebugName(child._owner));
    }

    path.push(getComponentOrElementDebugName(child));

    if (child.props.children) {
        return buildComponentPath(child.props.children, path);
    }

    return path;
}

export class ErrorBoundary extends Component {
    static getDerivedStateFromError(error) {
        return {error};
    }

    state = {error: null, info: null};

    componentDidCatch(error, info) {
        this.sendToEDAP(this.props.children, info);

        if (process.env.NODE_ENV === 'production' && window.Sentry) {
            window.Sentry.captureException(String(error), {extra: info});
        }
    }

    sendToEDAP = (child, error) => {
        const path = buildComponentPath(child).join(' > ');
        pushEdapEvent('generic.error', {
            actionlocation: path,
            logmessage: String(
                error.componentStack || error.stack || error.message
            ).trim(),
        });
    };

    render() {
        const {children, Fallback} = this.props;
        const {error} = this.state;
        if (error !== null) {
            return <Fallback error={error} />;
        }
        return children;
    }
}

export function withErrorBoundary(
    children,
    Fallback = process.env.NODE_ENV === 'production' ? 'span' : ErrorPanel
) {
    return <ErrorBoundary Fallback={Fallback}>{children}</ErrorBoundary>;
}
